"use client";

import {
  Placeholder as SitecorePlaceholder,
  useSitecoreContext,
  ComponentRendering,
  RouteData,
  Field,
  Item,
} from "@sitecore-jss/sitecore-jss-nextjs";
import MissingComponent from "../MissingComponent";
import styles from "./placeholder.module.css";

type PlaceholderProps = {
  name: string;
  classname?: string;
  rendering:
    | ComponentRendering
    | RouteData<Record<string, Field | Item | Item[]>>;
  isAside?: boolean;
};

const Placeholder = ({
  name,
  classname,
  rendering,
  isAside,
}: PlaceholderProps): JSX.Element | null => {
  const { sitecoreContext } = useSitecoreContext();
  const isEditing = sitecoreContext?.pageEditing;
  const placeholders = rendering.placeholders;

  if (!placeholders || !placeholders[name]) return null;

  const placeholder = (
    <SitecorePlaceholder
      name={name}
      rendering={rendering}
      missingComponentComponent={MissingComponent}
      classname={classname}
      isAside={isAside}
    />
  );

  return isEditing && placeholders[name]?.length === 0 ? (
    <div className={styles.placeholderContainer}>{placeholder}</div>
  ) : (
    placeholder
  );
};

export default Placeholder;
